"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  if (loading) {
    return <>
        <div className="hidden lg:flex gap-1">
          <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
          <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
          <div className="h-9 w-16 bg-muted-light animate-pulse rounded-md" />
        </div>
        <div className="lg:hidden">
          <div className="h-9 w-9 bg-muted-light animate-pulse rounded-md" />
        </div>
      </>;
  }
  const filteredMenuItems = menuItems.filter(item => item.label !== "Book Appointment");
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden lg:flex">
        <NavigationMenuList className="gap-0">
          {filteredMenuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="relative px-5 py-2 text-sm font-medium text-white transition-colors duration-300 hover:!bg-transparent focus:!bg-transparent after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-300 hover:after:w-full focus:after:w-full">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="lg:hidden hover:!bg-transparent focus:!bg-transparent text-secondary" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
        {isMobileMenuOpen ? <X className="size-5" /> : <Menu className="size-5" />}
      </Button>

      {}
      {isMobileMenuOpen && <div className="absolute top-full left-0 w-full bg-white border-t border-border shadow-medium lg:hidden">
          <nav className="container mx-auto px-4 py-4">
            <ul className="flex flex-col gap-2">
              {filteredMenuItems.map((item, i) => <li key={item.id} data-index={i}>
                  <Link to={item.href || "#"} className="block px-4 py-2 text-sm font-medium text-white hover:bg-accent hover:text-accent-foreground rounded-md transition-colors" onClick={() => setIsMobileMenuOpen(false)}>
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>
        </div>}
    </>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header id="header" className={`sticky top-0 z-50 w-full bg-[#FA8E8E] transition-all duration-300 ${isScrolled ? "h-[60px] backdrop-blur-md border-b border-secondary/20" : "h-[80px] border-b border-transparent"}`}>
      <div className="container mx-auto px-4 h-full flex items-center justify-between">
        <Link to="/" className="flex-shrink-0">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1537983/img/axion_physiotherapy_logo.png" alt="Site Logo" className="h-7" />
        </Link>

        {}
        <MenuProvider menu_id="3" className="flex-1 flex justify-center">
          <HeaderMenuConsumer />
        </MenuProvider>

        {}
        <Button asChild className="ml-4 text-white transition-all duration-150 ease-out hover:scale-[1.03] hover:bg-primary-hover focus:scale-100 focus:bg-primary-active hover:!bg-primary-hover focus:!bg-primary-active">
          <Link to="/BookAppointmentPage">Book Appointment</Link>
        </Button>
      </div>
    </header>;
}